import React, { useMemo, useRef } from 'react';
import { Box, Button, IconButton, Stack, Tooltip, Typography } from '@mui/material';
import { Delete } from '@mui/icons-material';
import { MaterialReactTable } from 'material-react-table';
import { MRT_Localization_PT_BR } from 'material-react-table/locales/pt-BR';

import CustomDialog from '../../../layout/CustomDialog';
import Input from '../../../form/Input';
import Checkbox from '../../../form/Checkbox';
import { getApiUrl } from '../../../../utils/retornaTratamentoURL';

function FormComprovantes({
    dados,
    itens,
    novoComprovante,
    preview,
    inputFileRef,

    isLoading,
    isSubmitting,
    openConfirmDelete,

    handleFileChange,
    handleChange,
    handleSalvar,
    handlePrepararExclusao,
    handleConfirmDelete,
    handleCloseDelete,
    limparComprovante,

    onClose,
}) {
    const columns = useMemo(
        () => [
            {
                id: 'Comprovantes',
                header: 'Comprovantes',
                columns: [
                    {
                        accessorKey: 'arquivo',
                        header: 'Arquivo',
                        Cell: ({ row }) => {
                            const filename = row.original.arquivo;
                            const isPdf = filename?.toLowerCase().endsWith('.pdf');
                            const pastaPublica = isPdf ? 'pdf' : 'imagens';
                            const url = getApiUrl(`${pastaPublica}/${filename}`);

                            return (
                                <span
                                    style={{
                                        cursor: 'pointer',
                                        color: 'blue',
                                        textDecoration: 'underline',
                                    }}
                                    onClick={() => window.open(url, '_blank')}
                                >
                                    {`Visualizar ${isPdf ? 'PDF' : 'Imagem'} => ${filename}`}
                                </span>
                            );
                        },
                    },
                    {
                        accessorKey: 'ativo',
                        header: 'Ativo',
                        Cell: ({ row }) => (row.original?.ativo ? 'Sim' : 'Não'),
                    },
                ],
            },
        ],
        []
    );

    const podeSalvar = !!novoComprovante?.arquivo?.length && !isSubmitting;

    return (
        <>
            {openConfirmDelete && (
                <CustomDialog
                    title="Excluir comprovante"
                    content="Você tem certeza?"
                    onClose={handleCloseDelete}
                    onConfirm={handleConfirmDelete}
                />
            )}

            <Stack
                direction={{ xs: 'column', md: 'row' }}
                spacing={2}
                justifyContent="space-between"
                alignItems={{ xs: 'flex-start', md: 'center' }}
                sx={{ mb: 2 }}
            >
                <Typography variant="body1">
                    <strong>Total de comprovantes:</strong> {Array.isArray(itens) ? itens.length : 0}
                </Typography>

                <Stack direction="row" spacing={1}>
                    <Button variant="contained" color="secondary" onClick={onClose}>
                        Voltar
                    </Button>
                </Stack>
            </Stack>

            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    marginTop: '1rem',
                    flexWrap: 'wrap',
                    gap: 1,
                    mb: 2,
                }}
            >
                <Input
                    ref={inputFileRef}
                    text="PDF do comprovante"
                    type="file"
                    name="novoComprovante.arquivo"
                    handleOnChange={handleFileChange}
                    inputWidth="400px"
                    multiple={true}
                    accept="application/pdf"
                />

                <Checkbox
                    title="Ativo quando marcado"
                    text="Ativo"
                    name="ativo"
                    handleOnChange={handleChange}
                    value={novoComprovante.ativo}
                    checked={!!novoComprovante.ativo}
                />

                <Button variant="contained" color="inherit" onClick={limparComprovante}>
                    Limpar
                </Button>

                <Button
                    variant="contained"
                    color={novoComprovante.funcao?.toLowerCase() === 'deletar' ? 'error' : 'info'}
                    onClick={handleSalvar}
                    disabled={!podeSalvar}
                >
                    {novoComprovante.funcao || 'Adicionar'}
                </Button>
            </Box>

            {!!preview?.length && (
                <Box sx={{ mb: 2 }}>
                    <Typography variant="body2">
                        <strong>Arquivos selecionados:</strong> {preview.map((f) => f.name).join(', ')}
                    </Typography>
                </Box>
            )}

            <MaterialReactTable
                columns={columns}
                data={itens}
                enableRowActions
                getRowId={(row) => row.uuid}
                localization={MRT_Localization_PT_BR}
                initialState={{
                    showColumnFilters: true,
                    density: 'compact',
                }}
                state={{
                    isLoading,
                }}
                renderRowActions={({ row }) => (
                    <Box sx={{ display: 'flex', gap: '1rem' }}>
                        <Tooltip arrow placement="right" title="Deletar">
                            <span>
                                <IconButton
                                    color="error"
                                    onClick={() => handlePrepararExclusao(row.original)}
                                    disabled={isSubmitting}
                                >
                                    <Delete />
                                </IconButton>
                            </span>
                        </Tooltip>
                    </Box>
                )}
                renderDetailPanel={({ row }) => (
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'space-around',
                            alignItems: 'center',
                        }}
                    >
                        <div
                            style={{
                                display: 'inline-block',
                                cursor: 'pointer',
                                margin: '0 10px 0 0',
                            }}
                            onClick={() => {
                                const url = getApiUrl(`pdf/${row.original.arquivo}`);
                                window.open(url, '_blank');
                            }}
                            title="Clique para abrir em uma nova aba"
                        >
                            <embed
                                type="application/pdf"
                                src={getApiUrl(`pdf/${row.original.arquivo}`)}
                                width={60}
                                height={80}
                                style={{
                                    borderColor: 'black',
                                    border: 'solid 0.05em',
                                }}
                            />
                        </div>
                        <Box sx={{ textAlign: 'left' }}>
                            <Typography variant="h6">Comprovante</Typography>
                        </Box>
                    </Box>
                )}
                positionExpandColumn="first"
                positionActionsColumn="first"
                positionToolbarAlertBanner="bottom"
            />
        </>
    );
}

export default FormComprovantes;
